module.exports = __webpack_public_path__ + "static/media/ic-file-xls.c857fc0b.svg";